import { render } from "./AppLayout.vue?vue&type=template&id=2a047429"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script